import React from 'react';
import Icon from '../../../components/AppIcon';

const IndustryRecognition = ({ recognition }) => {
  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-sm hover:shadow-md transition-all duration-300">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name={recognition?.icon} size={24} className="text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-semibold text-foreground mb-2">
            {recognition?.title}
          </h4>
          <p className="text-sm text-muted-foreground mb-3">
            {recognition?.description}
          </p>
          <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              <span>{recognition?.year}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Building2" size={14} />
              <span>{recognition?.organization}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustryRecognition;